import { find } from 'lodash';
import { useBrandConfiguration } from '../../brands/context';
import { Order } from '../../brands/models/Order';
import { useApis } from '../useApis';
import { useSerpTranslation } from '../useI18n';
const sortOptions = [
    {
        label: 'relevancy',
        order: Order.Relevancy,
    },
    {
        label: 'recency',
        order: Order.Recency,
    },
    {
        label: 'price_asc',
        order: Order.PriceAsc,
    },
    {
        label: 'price_desc',
        order: Order.PriceDesc,
    },
];
const translate = (name) => {
    const { t } = useSerpTranslation();
    return t(`header.filters.sort.${name}`);
};
export const useSort = ({ setSort }) => {
    const { t } = useSerpTranslation();
    const { sortExplanationPath } = useBrandConfiguration();
    const { publicUri } = useApis();
    // building the TranslationComponent manually (<Trans> not being exported by Unified Shell for now)
    const sortExplanationUrl = new URL(sortExplanationPath, publicUri).toString();
    const linkTitle = t('header.filters.sort.explanation.link_title');
    const explanation = t('header.filters.sort.explanation.text');
    const explanationPartLink = t('header.filters.sort.explanation.link_text');
    const modalTitle = t('header.filters.sort.title');
    const prefixButton = t('header.filters.sort.prefix');
    const ariaSortingSelector = t('header.filters.sort.aria_label.sort_button');
    const ariaKnowMore = t('header.filters.sort.aria_label.rules_button');
    const translateTexts = {
        sortExplanationUrl,
        linkTitle,
        explanation,
        explanationPartLink,
        modalTitle,
        prefixButton,
        ariaSortingSelector,
        ariaKnowMore,
    };
    const generateMenuItems = () => sortOptions.map((orderItem) => ({
        id: orderItem.label,
        children: translate(orderItem.label),
        elementType: 'button',
        onAction: (id) => {
            const { order } = find(sortOptions, { label: id });
            setSort(order);
        },
    }));
    const getOrderName = (order) => {
        const { label } = find(sortOptions, { order });
        return translate(label);
    };
    const getOrderKey = (order) => {
        const { label } = find(sortOptions, { order });
        return label;
    };
    return { generateMenuItems, getOrderName, getOrderKey, translateTexts };
};
